import { createSlice } from '@reduxjs/toolkit'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { requestGlobalPartnerData } from './api/requestGlobalPartnerData'
import { GLOBAL_PARTNER_DATA } from './constants'
import { initialState } from './initialState'

const globalPartnerSlice = createSlice({
  initialState,
  name: GLOBAL_PARTNER_DATA,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(requestGlobalPartnerData.pending, (state) => {
        state.message = 'fetching global partner data'
        state.status = RequestStatus.PENDING
      })
      .addCase(requestGlobalPartnerData.rejected, (state, action) => {
        if (action.error.message) {
          state.message = action.error.message
        }
        state.status = RequestStatus.REJECTED
      })
      .addCase(requestGlobalPartnerData.fulfilled, (state, action) => {
        state.message = 'data fetched successful'
        state.data = action.payload
        state.meta = action.meta
        state.status = RequestStatus.FULFILLED
      }),
})

export const {} = globalPartnerSlice.actions

export default globalPartnerSlice.reducer
